import React from 'react';
import classes from './style.module.scss';

const baseClass = 'field-component';

interface IProps {
  value: string | number;
  onChange: (value: string | number) => void;
  label: string;
  required?: boolean;
  placeholder?: string;
  type?: 'text' | 'number' | 'email' | 'password' | 'date';
  error?: boolean;
  fieldType?: 'row' | 'column';
  disabled?: boolean;
  as?: 'input' | 'textarea'; // <--- новое свойство
  rows?: number;
}

const Field = ({ value, onChange, label, required, placeholder, type, error, fieldType = 'column', disabled, as = 'input', rows = 3 }: IProps) => {

  if (type === 'date' && typeof value === 'string') {
    value = value.split('T')[0];
  }

  return (
    <div className={`${classes[baseClass]} ${classes[`${baseClass}--${fieldType}`]}`}>
      {label && <label className={required ? classes.required : ''}>{label}</label>}
      {disabled ? (
        <span className={classes[`${baseClass}__disabled-value`]}>{value}</span>
      ) : (
        as === 'textarea' ? (
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`${error ? classes.error : ''}`}
            rows={rows}
            id={`textAreaField-${Math.random().toString(36).substr(2, 9)}`}
          />
        ) : (
          <input
            type={type}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`${error ? classes.error : ''}`}
            step={type === 'number' ? 'any' : undefined}
          />
        )
      )}
    </div>
  );
}

export default Field